import classNames from 'classnames';
import { SelectDrawer } from '@Components/Base';
import { OptionExtended } from '@Components/types/options';

import styles from './presentation-mobile-request-header.module.css';

interface PresentationMobileRequestHeaderProps {
  labelSelectOption?: string;
  selectOptions?: OptionExtended[];
  children?: React.ReactNode;
  selectedValue?: string;
  showSelect?: boolean;
  requestType: 'ESS' | 'MR';
  handleSelect?: (label: string, value: string | null) => void;
  onRequestSelectorOpen?: () => void;
}

const PresentationMobileRequestHeader: React.FC<
  PresentationMobileRequestHeaderProps
> = ({
  children,
  selectOptions,
  handleSelect,
  selectedValue = '',
  onRequestSelectorOpen,
  requestType = 'ESS',
  labelSelectOption,
  showSelect = true,
}) => {
  return (
    <div
      className={classNames(
        styles.presentationHeader,
        styles.mobile,
        !showSelect ? styles.mrHideHeight : null
      )}
    >
      <div className={styles.presentationActions}>
        {requestType === 'MR' ? (
          <div className={styles.mrCaption}>My Requests</div>
        ) : (
          <div className={styles.presentationMobileSelectTypeSection}>
            {showSelect && (
              <>
                <span className={styles.requestTypeTitle}>
                  {labelSelectOption}
                </span>
                {selectOptions && (
                  <SelectDrawer
                    items={selectOptions}
                    caption={selectedValue}
                    title="Select Request Type"
                    handleSelect={handleSelect}
                    onOpen={onRequestSelectorOpen}
                    showCounter
                    mobileView
                  />
                )}
              </>
            )}
          </div>
        )}

        <div>{children}</div>
      </div>
    </div>
  );
};

export default PresentationMobileRequestHeader;
